import { Component, OnInit } from '@angular/core';
@Component({
    selector: 'app-authlayout',
    templateUrl: './authlayout.component.html',
    styleUrls: ['./authlayout.component.scss'],
    standalone: false
})
export class AuthlayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
